<template>
  <div class="s-web" ref="sWeb">
    <k-header :headerData="headerTeacher">
    </k-header>
    <div class="darg-wrap">
      <drag>
        
        <div class="work" slot='uLeft'>
          <code-editor></code-editor>
        </div>
        <div class="work" slot='dLeft'>
          <h1>下左侧</h1>
          <button class="btn" @click="getCode">获取代码</button>
        </div>

        <div class="work" slot='uRight'>
          <h1>上右侧</h1>
        </div>
        <div class="work" slot='dRight'>
          <h1>下右侧</h1>
        </div>

      </drag>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Drag from '@/components/Drag'
import kHeader from '@/components/Header'
import CodeEditor from '@/components/WebEditor'
export default {
  components: {
    Drag,
    kHeader,
    CodeEditor
  },
  data () {
    return {
      headerTeacher: {
        role: '教师端',
        roomId: this.$route.params.roomId,
        number: '0'
      }
    }
  },
  mounted () {
  },
  methods: {
    getCode() {
      console.log(this.$store.state.editor.getValue())
      // this.teacherEditor.setValue('')
    }
  }
}
</script>

<style lang="scss">
  .darg-wrap{
    width: 100%;
    height: calc(100% - 48px);
    position: absolute;
    bottom: 0;
    right: 0;

    .work{
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// drag.vue?046c1b86